import { apiMethods } from '@services/methods'

import { ParkingBaseURL } from '@services/common/common'
import { setRoles, setUsers } from './slice'

const endpoints = {
  loadUsers: `${ParkingBaseURL}/admin/operational-users`,
  addUsers: `${ParkingBaseURL}/admin/operational-users/add`,
  updateUser: `${ParkingBaseURL}/admin/operational-users/update`
}

export const updateStatus = (body) => {
  return async (dispatch) => {
    const { ok, res } = await apiMethods.authPost({
      url: endpoints.updateUser,
      body
    })

    console.log(res)

    if (ok) {
      const { ok, res } = await apiMethods.authGet({
        url: endpoints.loadUsers
      })

      const users = res.data.users.filter(user => {
        return user.status !== 'deleted'
      })
      dispatch(setUsers(users))
    }

  }
}

export const loadUsersRequest = () => {
  return async (dispatch) => {
    const { ok, res } = await apiMethods.authGet({
      url: endpoints.loadUsers
    })


    if (ok) {
      const users = res.data.users.filter(user => {
        return user.status !== 'deleted'
      })
      
      dispatch(setUsers(users))

      const roles = []
      res.data.roles.map(role => {
        const item =  { value: role._id, label: role.name }
        roles.push(item)
      })
      dispatch(setRoles(roles))
    }

    // dispatch(loadCommerces(commerce))
  }
}

export const addUserRequest = (payload) => {
  return async (dispatch) => {
    const { ok, res } = await apiMethods.authPost({
      url: endpoints.addUsers,
      body:payload
    })

    if (ok) {
      const { ok, res } = await apiMethods.authGet({
        url: endpoints.loadUsers
      })

      const users = res.data.users.filter(user => {
        return user.status !== 'deleted'
      })
      
      dispatch(setUsers(users))
    }
  }
}
